import { LoginWrapper } from "../../components";

export default function LoginPage() {
  return (
    <div className="spacer-md">
      <LoginWrapper />
    </div>
  );
}
